<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <investment-amount-duration
              [derrors]="derrors"
              [isSwisslife]="partnerFlux?.value === 'SWISSLIFE'"
            ></investment-amount-duration>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
